import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import StandardFrontCard from '../SingleAction/SingleActionDetails';
import PetitionDetails from './PetitionDetails';
import PetitionSuccess from './PetitionSuccess';
import FindLocalRep from '../LocalRep/FindLocalRep';

const Petition = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/petition/start"
                            name="PetitionStart"
                            exact
                            component={StandardFrontCard}
                        />
                        <Route
                            path="/petition"
                            name="PetitionDetails"
                            exact
                            component={PetitionDetails}
                        />
                        <Route
                            path="/petition/success"
                            name="PetitionSuccess"
                            exact
                            component={PetitionSuccess}
                        />
                        <Route
                            path="/petition/findRep"
                            name="PetitionFindRep"
                            exact
                            component={FindLocalRep}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Petition;



// WEBPACK FOOTER //
// ./src/containers/Petition/Petition.jsx